export default [
    {
        id: 1,
        type: "text",
        title: "Persönliche Angaben",
        items: [
            {
                id: 1,
                type: "small",
                text: "Semester",
            },
            {
                id: 2,
                type: "medium",
                text: "Studiengang",
            },
        ],
    },
    {
        id: 2,
        type: "matwis-p",
        title: "Wie bewerten Sie diese Veranstaltung (in Schulnoten)?",
        rowTitle: "Praktikumsversuch",
        items: [
            {
                id: 3,
                text: "Stahl fliegt (Prof. Dr. Sarah Doz, Betreuer: Hans Wurst)",
            },
            {
                id: 4,
                text: "Stahl fliegt (Prof. Dr. Sarah Doz, Betreuer: Hans Wurst)",
            },
            {
                id: 5,
                text: "Stahl fliegt (Prof. Dr. Sarah Doz, Betreuer: Hans Wurst)",
            },
            {
                id: 6,
                text: "Stahl fliegt (Prof. Dr. Sarah Doz, Betreuer: Hans Wurst)",
            },
        ],
    },
    {
        id: 3,
        type: "text",
        items: [
            {
                id: 7,
                text: 'Gerne können Sie auch Lob und Kritik angeben. Insbesondere falls Sie "Sehr gut" oder "Mangelhaft" angekreuzt haben, würde uns der Grund interessieren:',
            },
        ],
    },
];